'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import styles from './styles.module.css'
import AnimatedSection from '@/components/AnimatedSection'

const Blog: React.FC = () => {
  const router = useRouter()
  
  const handleViewAllArticles = () => {
    router.push('/articles')
  }
  
  const handleArticleClick = (articleId: number) => {
    if (articleId === 1) {
      router.push('/articles/kiberataka-kak-zashhitit-svoj-sajt-i-biznes/')
    } else if (articleId === 2) {
      router.push('/articles/skolko-ekonomit-kompaniya-perevodya-bumazhnye-otchyoty-v-biznes-proczess/')
    } else if (articleId === 3) {
      router.push('/articles/lichnyj-kabinet-kak-konkurentnoe-preimushhestvo/')
    }
  }
  const articles = [
    {
      id: 1,
      title: 'Кибератака — как защитить свой сайт и бизнес',
      description: 'В сфере ИТ-разработки среди заказчиков существует распространённое мнение, что основная задача разработчиков заключается в программировании, создании кода, и в предпроектном исследовании нет необходимости. Такое мнение схоже с утверждением о том, что основная задача риэлтора — быстро оформить договор.',
      image: '/images/blog/redesign/blog-1.png'
    },
    {
      id: 2,
      title: 'Сколько экономит компания, переводя бумажные отчеты в бизнес-процесс?',
      description: 'Новые возможности для молоды специалистов и ИТ-сообщества г. Иркутска',
      image: '/images/blog/redesign/blog-2.png'
    },
    {
      id: 3,
      title: 'Личный кабинет как конкурентное преимущество',
      description: 'В этой статье мы расскажем, как личный кабинет может стать конкурентным преимуществом для вашей компании и почему его стоит внедрить уже сегодня.',
      image: '/images/blog/redesign/blog-3.png'
    }
  ]

  return (
    <section className={styles.blog}>
      <div className={styles.container}>
        {/* Block heading */}
        <div className={styles.heading}>
          <p className={styles.subtitle}>
            Блог
          </p>
          <h2 className={styles.title}>
            Наше экспертное мнение
          </h2>
        </div>

        {/* Article preview cards */}
        <div className={styles.articlesContainer}>
          {articles.map((article) => (
            <div key={article.id} className={styles.articleCard}>
              <div className={styles.articleContent}>
                {/* Article image */}
                <div className={styles.articleImage}>
                  <div 
                    className={styles.articleImageBg}
                    style={{ backgroundImage: `url('${article.image}')` }}
                  />
                </div>
                <AnimatedSection
                  animation="slideLeft"
                  delay={100}
                  duration={1500}
                  distance={20}
                  className={styles.content}
                >
                {/* Article content */}
                <div className={styles.articleText}>
                  <div className={styles.articleTextContent}>
                    <h3 
                      className={styles.articleTitle}
                      dangerouslySetInnerHTML={{ __html: article.title }}
                    />
                    <p 
                      className={styles.articleDescription}
                      dangerouslySetInnerHTML={{ __html: article.description }}
                    />
                  </div>

                  <button 
                    className={styles.articleLink}
                    onClick={() => handleArticleClick(article.id)}
                  >
                    <span className={styles.articleLinkText}>Подробнее</span>
                    <div className={styles.articleLinkIcon}>
                      <svg className={styles.iconSvg} viewBox="0 0 16 16" fill="none">
                        <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
                      </svg>
                    </div>
                  </button>
                </div>
                </AnimatedSection>
              </div>
            </div>
          ))}
        </div>

        {/* Show all articles button */}
        <div className={styles.buttonContainer}>
          <button 
            className={styles.button}
            onClick={handleViewAllArticles}
          >
            <span className={styles.buttonText}>Смотреть все статьи</span>
            <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
              <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  )
}

Blog.displayName = 'Blog'

export default Blog
